import './App.css';
import { isAndroid, isMobile } from 'react-device-detect';
import React, { useEffect, useState } from "react";
const axios = require('axios');

function App() {
  useEffect(() => {
    isMobile ? handleMobile() : handleDesktop();
  }, []);

  const handleMobile = () => {
    isAndroid ? handleAndroid() : handleIOS();
  }

  const handleDesktop = () => {
    window.location.replace('https://play.google.com/store/apps/details?id=com.acecookhome.android')
  }

  const handleIOS = async () => {
    const href = window.location.href;
    const local = href.indexOf('localhost');

    const url = (local === -1) ? 'https://admin.acecookhome.vn/api/v1/applecode' : 'http://ace.dev.techhaus.vn/api/v1/applecode';
    await axios.get(url)
      .then(function (response) {
        if (+response.status === 200) {
          window.location.replace(response.data.data.applelink)
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  };

  const handleAndroid = () => {
    window.location.replace('https://play.google.com/store/apps/details?id=com.acecookhome.android')
  };
  return (
    <div className="App">

    </div>
  );
}

export default App;
